import React from 'react';
import './Toggle.css';

const Toggle = ({
  checked = false,
  onChange,
  label,
  description,
  disabled = false,
}) => {
  return (
    <label className={`p-toggle ${disabled ? 'p-toggle--disabled' : ''}`}>
      <div className="p-toggle__switch">
        <input
          type="checkbox"
          checked={checked}
          onChange={onChange}
          disabled={disabled}
          className="p-toggle__input"
        />
        <span className="p-toggle__track" />
      </div>
      {(label || description) && (
        <div className="p-toggle__text">
          {label && <span className="p-toggle__label">{label}</span>}
          {description && <span className="p-toggle__description">{description}</span>}
        </div>
      )}
    </label>
  );
};

export default Toggle;
